import ApiService from '../../../services/apiService';

export default {
  isAssetMgmtFetch(context, type, offset, limit, searchItem, filters, orderBy, options) {
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItem);
    if (!searchJson) {
      searchJson = 'null';
    }
    let orderByJson = JSON.stringify(orderBy);
    if (!orderByJson) {
      orderByJson = 'null';
    }
    let params = {
      offset,
      limit,
      search_item: searchJson,
      filters: filtersJson,
      order_by: orderByJson,
      options: optionsJson,
    };
    return ApiService.instance.get(`/is-asset-mgmt/fetch/${type}`, { params }).then((response) => {
      return response.data;
    });
  },

  isAssetMgmtFetchCategoriesAndZones(context, type) {
    return ApiService.instance.get('/is-asset-mgmt/categories-zones', { params: { type } }).then((response) => {
      return response.data;
    });
  },
  isAssetMgmtFetchGeoMetaInfos(context, filters) {
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    return ApiService.instance
      .get('/is-asset-mgmt/geo-meta-infos/', {
        params: { filters: filtersJson },
      })
      .then((response) => {
        return response.data;
      });
  },

  isAssetMgmtFetchGeoClusters(context, floorDtwinId, geoBounds, searchItem, tagFilter, filters, options, stateKey) {
    let geoBoundsJson = JSON.stringify(geoBounds);
    if (!geoBoundsJson) {
      geoBoundsJson = 'null';
    }
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItem);
    if (!searchJson) {
      searchJson = 'null';
    }
    let params = {
      floor_dtwin_id: floorDtwinId,
      geo_bounds: geoBoundsJson,
      search_item: searchJson,
      tag_filter: tagFilter,
      filters: filtersJson,
      options: optionsJson,
      state_key: stateKey,
    };
    return ApiService.instance.get('/is-asset-mgmt/geo-clusters/', { params, timeout: 25000 }).then((response) => {
      return response.data;
    });
  },

  isAssetMgmtGetGeoClusterContent(
    context,
    clusterId,
    floorDtwinId,
    geoBounds,
    searchItem,
    tagFilter,
    filters,
    options
  ) {
    let geoBoundsJson = JSON.stringify(geoBounds);
    if (!geoBoundsJson) {
      geoBoundsJson = 'null';
    }
    let optionsJson = JSON.stringify(options);
    if (!optionsJson) {
      optionsJson = 'null';
    }
    let filtersJson = JSON.stringify(filters);
    if (!filtersJson) {
      filtersJson = 'null';
    }
    let searchJson = JSON.stringify(searchItem);
    if (!searchJson) {
      searchJson = 'null';
    }
    let params = {
      floor_dtwin_id: floorDtwinId,
      geo_bounds: geoBoundsJson,
      search_item: searchJson,
      tag_filter: tagFilter,
      filters: filtersJson,
      options: optionsJson,
    };
    return ApiService.instance
      .get(`/is-asset-mgmt/geo-clusters/break-open/${clusterId}`, { params })
      .then((response) => {
        return response.data;
      });
  },
};
